<template>
  <div class="statistics">
     <el-row class="line" style="margin-top:0px;">
      <div class="search_group">
          <el-radio-group v-model="searchTimebtn" @change = "getTime(searchTimebtn)" >
              <el-radio-button v-for='item in registrationTime_arr' :key='item.id' :label='item.Value'>{{item.Text}}</el-radio-button>
              <el-radio-button label='4'  class="nav-time">
                  <el-date-picker  v-model="customTime"  type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                      value-format="yyyy-MM-dd" @change="changeTime" :default-time="['00:00:00', '23:59:59']">
                  </el-date-picker>
              </el-radio-button>
          </el-radio-group>
      </div>
    </el-row>
     <el-row class="line" style="text-align:center" >
      <el-row :gutter="20" >
        <el-col :span="4"  v-for="(value , key) in PersonStatistic" :key='key'>
            <span class="round">{{value}}</span><br>
            <span>{{ key | getStatistictname}}</span>
        </el-col>
      </el-row>
    </el-row>
    <el-row  class="line">
      <el-select :disabled = 'loading' v-model="eCharttime"  style="margin-left:5px;" @change="getEchart">
          <el-option  value='1' label="最近30天"></el-option>
          <el-option  value='2' label="最近1年"></el-option>
      </el-select>
    </el-row>
    <el-row >
      <div class="echart1">
        <div id="myChart1" :style="{width: '100%', height: '250px'}" ></div>
      <div id="myChart2" :style="{width: '100%', height: '250px'}" ></div>
      </div>
      <div class="echart2">
        <div id="myChart3" :style="{width: '100%', height: '500px'}" ></div>
      </div>
    </el-row>
  </div>
</template>
<script>
import { formatDate } from '@/utils/index.js'
export default {
  name: 'statistics',
  data() {
    return {
      loading: false,
      searchTimebtn: '最近7天',
      eCharttime: '1',
      customTime: [
        formatDate(new Date(new Date() - 3600 * 1000 * 24 * 7), 'yyyy-MM-dd'),
        formatDate(new Date(), 'yyyy-MM-dd')],
      registrationTime_arr: [
        {
          id: 'absa465132416511234',
          Value: '今天',
          Text: '今天'
        }, {
          id: 'absa465132416513',
          Value: '最近3天',
          Text: '最近3天'
        }, {
          id: 'absa465132416514',
          Value: '最近7天',
          Text: '最近7天'
        }],
      myChart: null,
      PersonStatistic: null,
      option: []
    }
  },
  components: {
  },
  computed: {
  },
  mounted() {
    this.getStatistics()
    // 初始化图表
    this.myChart = {
      myChart1: this.$echarts.init(document.getElementById('myChart1')), // 柱状
      myChart2: this.$echarts.init(document.getElementById('myChart2')), // 折线
      myChart3: this.$echarts.init(document.getElementById('myChart3'))// 饼
    }
    this.getEchart()
  },
  methods: {
    // 获取图表数据
    getEchart() {
      Object.keys(this.myChart).forEach((key, index) => {
        this.myChart[key].showLoading()
      })
      // 图标数据请求
      var tempTime = null
      if (this.eCharttime === '2') {
        tempTime = formatDate(new Date(new Date() - 3600 * 1000 * 24 * 365), 'yyyy-MM-dd')
      } else {
        tempTime = formatDate(new Date(new Date() - 3600 * 1000 * 24 * 29), 'yyyy-MM-dd')
      }
      const req1 = this.$store.dispatch('GetPersonalProceduresByDate', { dateType: this.eCharttime })
      const req2 = this.$store.dispatch('GetPersonalAvgMinsByDate', { dateType: this.eCharttime })
      const req3 = this.$store.dispatch('GetPersonalScores', { startDate: tempTime, endDate: formatDate(new Date(), 'yyyy-MM-dd') })
      // 发送请求
      Promise.all([req1, req2, req3]).then((result) => {
        this.PersonalProceduresByDate = result[0]
        this.PersonalAvgMinsByDate = result[1]
        this.PersonalScores = result[2]
        this.drawLine()
      }).catch(() => {
        this.drawLine()
      })
    },
    // 画图
    drawLine() {
      // 柱状
      this.option[0] = {
        backgroundColor: '#FFF',
        title: {
          text: '个人诊断状态数据',
          subtext: '单位:个',
          top: '5'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['检查数', '阳性数'],
          y: '10',
          textStyle: {
            fontSize: 14
          }
        },
        grid: {
          left: '3%',
          right: '5.5%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          data: this.PersonalProceduresByDate.dates.map((data) => {
            return data.date
          })
        },
        yAxis: {},
        series: [{
          name: '检查数',
          type: 'bar',
          data: this.PersonalProceduresByDate.dates.map((data) => {
            return data.count
          }),
          itemStyle: {
            normal: {
              color: '#5AB1AF'
            }
          },
          markLine: {
            data: [
              { type: 'average', name: '平均值' }
            ]
          }
        },
        {
          name: '阳性数',
          type: 'bar',
          data: this.PersonalProceduresByDate.dates.map((data) => {
            return data.isPositiveCount
          }),
          itemStyle: {
            normal: {
              color: '#b6a2de'
            }
          },
          markLine: {
            data: [
              { type: 'average', name: '平均值' }
            ]
          }
        }]
      }
      // 折线
      this.option[1] = {
        backgroundColor: '#FFF',
        title: {
          text: '个人诊断耗时数据',
          subtext: '单位:分钟',
          top: '5'
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          left: '3%',
          right: '5.5%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          data: this.PersonalAvgMinsByDate.dates.map((data) => {
            return data.date
          })
        },
        legend: {
          data: ['平均耗时'],
          y: '10',
          textStyle: {
            fontSize: 14
          }
        },
        yAxis: {},
        series: [{
          name: '平均耗时',
          type: 'line',
          data: this.PersonalAvgMinsByDate.dates.map((data) => {
            return data.avgMins
          }),
          itemStyle: {
            normal: {
              color: '#397ee3',
              width: '3'
            }
          },
          markLine: {
            data: [
              { type: 'average', name: '平均值', color: '#B6A2DE' }
            ]
          }
        }]
      }
      // 饼
      this.option[2] = {
        title: {
          text: '个人审核得分占比情况',
          subtext: '单位:分',
          top: '5'
        },
        backgroundColor: '#fff',
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          x: 'right',
          y: '10',
          data: this.PersonalScores.scores.map((data) => {
            return data.scoreDesc
          })
        },
        calculable: true,
        series: [
          {
            name: '得分占比',
            type: 'pie',
            radius: '55%',
            center: ['50%', '60%'],
            data: this.PersonalScores.scores.map((data) => {
              return { value: data.count, name: data.scoreDesc }
            })
          }
        ]
      }
      Object.keys(this.myChart).forEach((key, index) => {
        this.myChart[key].clear()
        this.myChart[key].setOption(this.option[index])
        this.myChart[key].hideLoading()
      })
    },
    // 获取列表
    getStatistics() {
      this.loading = true
      this.$store.dispatch('GetPersonalTotalProcedures', { startDate: this.customTime[0], endDate: this.customTime[1] }
      ).then((result) => {
        this.loading = false
        var temp1 = Number(result.approvedRate * 100)
        temp1 += '%'
        result.approvedRate = temp1
        var temp2 = Number(result.isPositiveRate * 100)
        temp2 += '%'
        result.isPositiveRate = temp2
        this.PersonStatistic = result
      }).catch(() => {
        this.loading = false
      })
      for (let index = 0; index < document.getElementsByClassName('round').length; index++) {
        document.getElementsByClassName('round')[index].classList.remove('animation')
        setTimeout(function() { document.getElementsByClassName('round')[index].classList.add('animation') }, 100)
      }
    },
    changeTime() {
      this.searchTimebtn = '4'
      this.getStatistics()
    },
    getTime(value) {
      switch (value) {
        case '今天':
          this.customTime = [formatDate(new Date(), 'yyyy-MM-dd'), formatDate(new Date(), 'yyyy-MM-dd')]
          break
        case '最近3天':
          this.customTime = [formatDate(new Date(new Date() - 3600 * 1000 * 24 * 3), 'yyyy-MM-dd'), formatDate(new Date(), 'yyyy-MM-dd')]
          break
        case '最近7天':
          this.customTime = [formatDate(new Date(new Date() - 3600 * 1000 * 24 * 7), 'yyyy-MM-dd'), formatDate(new Date(), 'yyyy-MM-dd')]
          break
      }
      this.getStatistics()
    },
    // 条数
    handleSizeChange(val) {
      this.pageSize = val
      this.getStatistics()
    },
    // 分页
    handleCurrentChange(val) {
      this.currentPage = val
      this.getStatistics()
    }
  },
  filters: {
    getStatistictname(datas) {
      var temp = ''
      switch (datas) {
        case 'submittedCount':
          temp = '诊断数量'
          break
        case 'isPositiveCount':
          temp = ' 阳性数量'
          break
        case 'isPositiveRate':
          temp = ' 阳性率'
          break
        case 'avgScore':
          temp = '平均分'
          break
        case 'approvedCount':
          temp = '审核通过数量'
          break
        case 'approvedRate':
          temp = '审核通过率'
          break
        default:
          break
      }
      return temp
    }
  }
}
</script>
<style  rel="stylesheet/scss"  lang="scss" >
$background-color :  #F8F8F8;
$font-size:13px;
.statistics{
    .line{ //行间距
      margin-top: 10px;
      background-color: $background-color;
      padding: 10px 0;
    }
    .el-input__inner{ // 修改input高度
      height: 29px !important;
      font-size: $font-size;
    }
    .el-input__icon{
      line-height: 25px;
    }
    .el-date-editor .el-range-separator{ // 至
        line-height: 22px;
        font-size: $font-size;
        padding: 0;
    }
    .el-date-editor .el-range__close-icon{ // 日历时间清空删除按钮
      line-height: 22px;
    }
    .el-date-editor .el-range__icon{ // 时间图标
      line-height: 20px;
    }
    .search_name{ //搜索类型
      color: #3A4A64 ;
      padding-left: 10px;
      font-weight: bold;
      font-size: 13.5px;
      width: 72px;
      display: inline-block;
      text-align: left;
    }
    .search_group{ // 搜索区域
      display: inline-block;
      padding-left: 10px;
      .el-radio-button:first-child .el-radio-button__inner{ // ridio第一个按钮修改样式
        border-left: 1px solid #dcdfe6;
        border-radius: 3px;
        -webkit-box-shadow: none!important;
        box-shadow: none!important;
      }
      .el-radio-button:last-child .el-radio-button__inner{ // 最后一个按钮
        margin-top: .5px;
        border-left: 1px solid #dcdfe6;
        border-radius: 3px;
        -webkit-box-shadow: none;
        box-shadow: none;
      }
      .el-radio-button__inner{
        line-height: 3px;
        border-radius: 3px;
        border-left: 1px solid #dcdfe6;
      }
      .el-radio-button{ // 单选按钮间距
        margin-right: 10px;
      }
      .el-radio-button__orig-radio:checked+.el-radio-button__inner{
        color: #409eff;
        border-color: #c6e2ff;
        background-color: #ecf5ff;
        box-shadow: 0 0 0 0 transparent;
      }
      .nav-time .el-radio-button__inner{ // 日历input 边框
        border-left: none !important;
      }
      .el-button--mini, .el-button--mini.is-round{
         padding: 0;
      }
   }
   .echart1{
     display: inline-block;
     width: 60%;
     border-left: 5px solid #F8F8F8;
   }
   .echart2{
     display: inline-block;
     width: 40%;
   }
    #myChart1,#myChart2{
    border-bottom: 5px solid #F8F8F8;
   }
   #myChart3{
    border: 5px solid #F8F8F8;
    border-top:none;
   }
   .nowNum{
     background: #FF9D60;
     border-radius: 3px;
     display: inline-block;
     line-height: 28px;
     height: 27px;
     color: #FFFFFF;
     text-align: center;
     padding: 0 10px;
     min-width: 200px;
     margin-right:10px;
     margin-top: 10px;
     margin-bottom: 5px;
   }
   .el-table td{
    border-bottom: none;
    font-size: $font-size;
   }
   .el-table__row td{
     padding: 10px 0;
   }
   .page{
    text-align: center;
    margin-top: 30px;
    }
    .rounds{
      height: 80px;
      overflow: hidden;
    }
    .round{
      display: inline-block;
      background: #b6a2de;
      width: 70px;
      height: 70px;
      border-radius: 50px;
      color: #fff;
      line-height: 70px;
      margin-bottom: 5px;
      animation-fill-mode:forwards;
      -webkit-animation-fill-mode:forwards;
    }
}
.animation{
      -webkit-animation: mymove 1s;
      animation: mymove 1s;
    }
     @keyframes mymove
{
from {transform:scale(0,0); opacity: 0;}
to {transform:scale(1,1); opacity: 1;}
}

@-webkit-keyframes mymove
{
from {transform:scale(0,0); opacity: 0;}
to {transform:scale(1,1); opacity: 1;}
}
</style>


